module.exports = __webpack_public_path__ + "img/icono-yt.0e5f1361.svg";